import style from "./style.module.css"
import NoDataImage from "../../assets/no-data-found.svg"
const NoDataFound = ({ label="Data" }) => {
    return (
        <div className={style.mainDiv}>
            <img className={style.noDataFoundImg} src={NoDataImage} alt="..." />
            <h3 className={style.notFoundTxt}>No {label} Found!</h3>
        </div>
    )
}

export default NoDataFound;